'use client'

import { useTranslate } from '@repo/shared/hooks'
import { Badge, Card, Row } from '@repo/ui/components'

import { useIsDesktop } from '@repo/ui/hooks'
import { CardsItem } from './cards-item.component'
import { CardEmptyState } from './card.empty-state'
import { useGetBanks, UserUserBankAccount } from '@repo/services'
import { convertToCardNumber } from '@repo/tools'
import { CardsItemAction } from './cards-item.action'
import { useMemo } from 'react'
import { CardsCTA } from './cards.cta'

export type Card = {
  id: number | undefined
  enName: string | undefined
  card: string | undefined
  sheba: string | undefined
  default: boolean
}

export const CardsContainer = () => {
  const { t } = useTranslate()

  const { data, isLoading } = useGetBanks({})

  const cards: Card[] = useMemo(
    () =>
      (data?.data?.bankAccounts || []).map((bank: UserUserBankAccount) => ({
        id: bank.id,
        enName: bank.details?.bankName ?? 'Unknown',
        card:
          bank.type === 'card'
            ? convertToCardNumber(Number(bank.data))
            : undefined,
        sheba: bank.details?.iban,
        default: bank.default ?? false,
      })),
    [data?.data?.bankAccounts],
  )

  const isDesktop = useIsDesktop()

  return (
    <Card className='mb-9xl md:mb-0 !gap-0' withoutBorder>
      {isDesktop && (
        <CardsCTA showAddCard={cards.length !== 0} origin='container' />
      )}

      {cards.map((item: Card, index: number) => (
        <Row
          key={index}
          className='justify-between py-md px-md border-b border-neutral-surface-dark last:border-b-0'
        >
          <Row className='gap-md w-fit'>
            <CardsItem
              enName={item.enName || ''}
              card={item.card}
              sheba={item.sheba || ''}
            />
          </Row>

          <Row className='gap-md w-fit'>
            {item.default && (
              <Badge variant='liquid' color='neutral' size='sm'>
                {t('addCardPage_default')}
              </Badge>
            )}
            <CardsItemAction data={item} />
          </Row>
        </Row>
      ))}
      {cards.length === 0 && !isLoading && <CardEmptyState />}
    </Card>
  )
}
